var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.message,"placement":"top-start"}},[_c('badge',{attrs:{"type":"info"}},[_c('i',{staticClass:"fa fa-info-circle"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }